(() => {
  const ROOT = 'recently-viewed-products';
  const TRACK = '.resource-list--grid';
  const ITEM = '.resource-list__item';
  const CARDS_PER_CLICK = 4;

  // Distance from one card to the next (card width + gap), measured from the DOM
  const getStep = (track) => {
    const items = track.querySelectorAll(ITEM);
    if (items.length < 2) return 0;
    return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
  };

  // Inline styles only, so no stylesheet changes are needed
  const setDisabled = (button, disabled) => {
    button.disabled = disabled;
    button.style.opacity = disabled ? '0.3' : '';
    button.style.pointerEvents = disabled ? 'none' : '';
  };

  const updateArrows = (root) => {
    const track = root.querySelector(TRACK);
    const prev = root.querySelector('.slideshow-control--previous');
    const next = root.querySelector('.slideshow-control--next');
    const arrows = root.querySelector('slideshow-arrows');
    if (!track || !prev || !next) return;

    const maxScroll = track.scrollWidth - track.clientWidth;

    // Hide arrows when all cards already fit
    if (arrows) arrows.style.display = maxScroll <= 1 ? 'none' : '';

    setDisabled(prev, track.scrollLeft <= 1);
    setDisabled(next, track.scrollLeft >= maxScroll - 1);
  };

  const updateAll = () => document.querySelectorAll(ROOT).forEach(updateArrows);

  // Capture phase on window so this runs before the theme's on:click="/next"
  // handler, which has no slideshow to control in this section
  window.addEventListener('click', (event) => {
    const button = event.target.closest(`${ROOT} .slideshow-control`);
    if (!button) return;

    const root = button.closest(ROOT);
    const track = root.querySelector(TRACK);
    const step = track ? getStep(track) : 0;
    if (!step) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const direction = button.classList.contains('slideshow-control--previous') ? -1 : 1;

    // Round to the nearest card so a manual swipe never leaves a half card
    const currentIndex = Math.round(track.scrollLeft / step);
    const targetIndex = Math.max(0, currentIndex + direction * CARDS_PER_CLICK);

    track.scrollTo({ left: targetIndex * step, behavior: 'smooth' });
  }, true);

  // Scroll events don't bubble, but a capturing listener still receives them
  document.addEventListener('scroll', (event) => {
    const target = event.target;
    if (target instanceof Element && target.matches(`${ROOT} ${TRACK}`)) {
      updateArrows(target.closest(ROOT));
    }
  }, { capture: true, passive: true });

  window.addEventListener('resize', updateAll);
  document.addEventListener('shopify:section:load', updateAll);

  // Cards are hydrated client-side, so re-check whenever the section content changes
  let frame = null;
  new MutationObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      updateAll();
    });
  }).observe(document.body, { childList: true, subtree: true });

  updateAll();
})();